import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./Employee/Main";
import Form from "./Employee/Form";

// Utils
import { getData, getAlert, getDataWithComp } from "../../../utils/SamuiUtils";
import { InitialDataEmployee } from "../../../model/InitialData/InitialDataEmployee";

const Employee = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [dataEmpPosition, setDataEmpPosition] = useState([]);
  const [dataEmpRole, setDataEmpRole] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDataEmployee());

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      // ดึงข้อมูลจาก Tb_Set_Employee ทั้งหมด
      const masterList = await getDataWithComp(
        "View_Set_Employee",
        "Order By Emp_Id"
      );
      const dataPosition = await getData("Tb_Set_Position", "1=1");
      const dataRole = await getData("Tb_Set_Role", "1=1");
      if (dataPosition && dataPosition.length > 0) {
        setDataEmpPosition(dataPosition);
      } else {
        setDataEmpPosition([]);
      }
      if (masterList && masterList.length > 0) {
        masterList.sort((a, b) => a.Emp_Id - b.Emp_Id);
        const positions = dataPosition || [];
        const mapped = masterList.map((emp) => ({
          ...emp,
          PST_Name: positions.find(
            (p) => Number(p.PST_Id) === Number(emp.Emp_Position)
          )?.PST_Name || "-",
        }));
        setDataMasterList(mapped);
      }
      if (dataRole && dataRole.length > 0) {
        setDataEmpRole(dataRole);
      } else {
        setDataEmpRole([]);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchPositionData = async () => {
    try {
      const dataPosition = await getData("Tb_Set_Position", "1=1");
      if (dataPosition && dataPosition.length > 0) {
        setDataEmpPosition(dataPosition);
      } else {
        setDataEmpPosition([]);
      }
      return dataPosition || [];
    } catch (error) {
      getAlert("FAILED", error.message);
      return [];
    }
  };

  const fetchRoleData = async () => {
    try {
      const dataRole = await getData("Tb_Set_Role", "1=1");
      if (dataRole && dataRole.length > 0) {
        setDataEmpRole(dataRole);
      } else {
        setDataEmpRole([]);
      }
      return dataRole || [];
    } catch (error) {
      getAlert("FAILED", error.message);
      return [];
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");
    setFormData({
      emp_id: item.Emp_Id,
      emp_code: item.Emp_Code,
      emp_prefix: item.Emp_Prefix,
      emp_name: item.Emp_Name,
      emp_position:
        item.Emp_Position !== undefined && item.Emp_Position !== null
          ? String(item.Emp_Position)
          : "",
      emp_startdate: item.Emp_StartDate,
      emp_tel: item.Emp_Tel,
      emp_status: item.Emp_Status,
      emp_uuser: item.Emp_UUser,
      emp_ppass: item.Emp_PPass,
      emp_role: item.Emp_Role !== undefined && item.Emp_Role !== null
        ? String(item.Emp_Role)
        : "",
      comp_id: item.Comp_Id,
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลพนักงาน"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลพนักงาน"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                  dataEmpPosition={dataEmpPosition}
                  onRefreshPosition={fetchPositionData}
                  dataEmpRole={dataEmpRole}
                  onRefreshRole={fetchRoleData}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Employee;

